<template>
  <div :class="[isLineOrBarChart ? 'col-12' : 'col-md-6']">
    <div class="card card-chart">
      <div class="card-header">
        <div class="row">
          <div class="col-md-6">
            <h5 class="card-title">{{ chart.title }}</h5>
          </div>
          <div class="col-md-6">
            <b-button
              @click="$emit('delete', chart.id)"
              variant="danger"
              size="sm"
              class="card-title float-right btn-icon"
            >
              <i class="fas fa-times"></i>
            </b-button>
            <b-button
              @click="$emit('show-form', chart.id)"
              variant="warning"
              size="sm"
              class="card-title float-right btn-icon"
            >
              <i class="fa fa-edit"></i>
            </b-button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="text-center">
          <BSpinner class="text-center" v-if="isLoading" />
        </div>

        <canvas height="250" :id="`chart-${chart.id}`"></canvas>
      </div>
      <div class="card-footer"></div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import "chartjs-plugin-colorschemes";
import { BSpinner, BButton } from "bootstrap-vue";

export default {
  components: {
    BSpinner,
    BButton
  },
  props: {
    type: {
      type: String,
      require: true
    },
    chart: {
      type: Object,
      required: true
    },
    deleteChart: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      isLoading: true
    };
  },
  computed: {
    schema() {
      return this.chart.schema.reduce((acc, field) => {
        return {
          ...acc,
          [field.name]: field
        };
      }, {});
    },
    isLineOrBarChart() {
      return ["line", "bar"].includes(this.chart.type);
    }
  },
  mounted() {
    this.fetchData()
      .then(this.buildOptions)
      .then(this.render)
      .finally(() => (this.isLoading = false));
  },
  methods: {
    fetchData() {
      return this.$http.get(this.chart.data_endpoint);
    },
    handleDelete(id) {
      this.deleteChart(id);
    },
    render(options) {
      const ctx = document
        .getElementById(`chart-${this.chart.id}`)
        .getContext("2d");
      new Chart(ctx, options);
    },
    setDataLabels(groupBy) {
      return (labels, row) => {
        labels.push(row[groupBy]);
        return labels;
      };
    },
    setDatasets(metrics) {
      return (datasets, row) => {
        return metrics.reduce((acc, metric, index) => {
          if (datasets[index] === undefined) {
            datasets[index] = {
              label: this.schema[metric].label,
              data: []
            };
          }
          datasets[index].data.push(row[metric]);
          return datasets;
        }, datasets);
      };
    },
    buildOptions({ data: response }) {
      const options = {
        type: this.type,
        options: {
          plugins: {
            colorschemes: {
              scheme: "brewer.Paired12"
            }
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          },
          maintainAspectRatio: false
        },
        data: {
          labels: [],
          datasets: []
        }
      };

      options.data.labels = response.reduce(
        this.setDataLabels(this.chart.dimensions[0]),
        []
      );

      options.data.datasets = response.reduce(
        this.setDatasets(this.chart.metrics),
        []
      );
      return options;
    }
  }
};
</script>
